import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import trucksService from "services/trucks.service";

import PageHeader from "components/PageHeader";
import TrucksList from "./components/TrucksList";
import Filter from "./components/Filter";
import Modal from "components/Modal";
import EditModal from "./components/EditModal";
import PopUpSuccess from "./components/PopUpSuccess";

import styles from "./Trucks.module.scss";
import ModalDelete from "./components/DeleteModal";

const Trucks = () => {
  const navigate = useNavigate()
  const [trucksList, setTrucksList] = useState([]);
  const [users, setUsers] = useState([]);
  const [filterResult, setFilterResult] = useState(null);
  const [filtered, setFiltered] = useState(false);
  const [editModal, setEditModal] = useState({ open: false, data: {} });
  const [deleteModal, setDeleteModal] = useState({ open: false, data: {} });
  const [success, setSuccess] = useState(false)
  const [currentScreen, setCurrentScreen] = useState({
    screen: "trucksList",
    title: "TRUCKS",
  });

  useEffect(() => {
    const controller = new AbortController();

    trucksService.getTrucks(controller.signal).then(
      ({ data }) => data?.length && setTrucksList(data),
      (error) => {
        if (error.name === "CanceledError" || error.name === "AbortError") return;
        console.error(error);
      },
    );

    trucksService.getUsersList(controller.signal).then(
      ({ data }) => data?.length && setUsers(data),
      (error) => {
        if (error.name === "CanceledError" || error.name === "AbortError") return;
        console.error(error);
      },
    );

    return () => controller.abort();
  }, []);

  useEffect(() => {
    if (!success) return;

    const controller = new AbortController();

    trucksService.getTrucks(controller.signal).then(
      ({ data }) => data?.length && setTrucksList(data),
      (error) => {
        if (error.name === "CanceledError" || error.name === "AbortError") return;
        console.error(error);
      },
    );
    const timeoutId = setTimeout(() => setSuccess(false), 4000);

    return () => {
      controller.abort();
      clearTimeout(timeoutId);
    };
  }, [success])

  return (
    <>
      <div className="container">
        <PageHeader title={currentScreen.title} />
        

        {currentScreen.screen === "trucksList" && (
          <>
            <Filter
              users={users}
              trucksList={trucksList}
              filterResult={filterResult}
              setFilterResult={setFilterResult}
              setCurrentScreen={setCurrentScreen}
              setFiltered={setFiltered}
            />
            <div className={styles.createTruckBlock}>
              <button onClick={() => navigate("/create_truck")}>+ Create truck</button>
            </div>
            {trucksList && (
              <TrucksList
                list={filtered ? filterResult : trucksList}
                setList={filtered ? setFilterResult : setTrucksList}
                setEditModal={setEditModal}
                setDeleteModal={setDeleteModal}
                deleteModal={deleteModal}
              />
            )}
          </>
        )}
        {editModal.open && (
          <Modal
            setShowModal={setEditModal}
            className={styles.editModal}
            content={<EditModal data={editModal.data} setShowModal={setEditModal} setSuccess={setSuccess}/>}
            hideCloseBtn={true}
          />
        )}
        {deleteModal.open && (
           <Modal
           setShowModal={setDeleteModal}
           className={styles.deleteModal}
           content={<ModalDelete data={deleteModal.data} setShowModal={setDeleteModal} setSuccess={setSuccess}/>}
           hideCloseBtn={true}
         />
        )}
        {success && <PopUpSuccess text={success} />} 
      </div>
    </>
  );
};

export default Trucks;
